<template>
  <div class="row">
    <div class="col">
      <div class="success-box">
        <h1>Success!</h1>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api';

export default {
  name: 'fetchrev-connection-success',
  computed: {
    token() {
      return this.$route.query.code;
    },
  },
  mounted() {
    API.sendFetchRevConnectionToken(this.token).then((resp) => {
      this.$toast('success', resp.message);
    }).catch((err) => {
      this.$toast('error', err.message);
    });
  },
};
</script>

<style>
</style>
